import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Field } from 'react-final-form';
import Form from '@piconetworks/pkg-form';

var _excluded = ["name", "required"];
var Other = {
  name: 'Other',
  Component: function Component(_ref) {
    var name = _ref.name,
      required = _ref.required,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Field, {
      label: "Address Line 1",
      required: required
    }, /*#__PURE__*/React.createElement(Field, _extends({
      name: name + ".address1",
      component: Form.Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React.createElement(Form.Field, {
      label: "Address Line 2"
    }, /*#__PURE__*/React.createElement(Field, _extends({
      name: name + ".address2",
      component: Form.Input,
      type: "text"
    }, rest))), /*#__PURE__*/React.createElement(Form.Field, {
      label: "City",
      required: required
    }, /*#__PURE__*/React.createElement(Field, _extends({
      name: name + ".city",
      component: Form.Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React.createElement(Form.Field, {
      label: "Region",
      required: required
    }, /*#__PURE__*/React.createElement(Field, _extends({
      name: name + ".region",
      component: Form.Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React.createElement(Form.Field, {
      label: "Zip Code"
    }, /*#__PURE__*/React.createElement(Field, _extends({
      name: name + ".post_code",
      component: Form.Input,
      type: "number"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))));
  }
};
var Other$1 = Other;

export { Other$1 as default };
//# sourceMappingURL=Other.js.map
